const patients = (state = [], action) => {
  switch (action.type) {
    case "SET_PATIENT_ENROLL_DATA":
      return {
        patientEnrollData: action.data,
      };
    case "SET_PATIENT_ACTIVE_DATA":
      return {
        patientActiveData: action.data,
      };
    case "SET_USER_BILLING_DATA":
      return {
        billingData: action.data,
      };
    default:
      return state;
  }
};

export default patients;
